/* template */
<template minapp="mpx" xlang="wxml"><es-picker :value="(innerValue)" :columns="(columns)" :showToolBar="(showToolBar)" @cancel="onCancel" @confirm="onConfirm" @input="onChange"/></template>

/* styles */
/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2fc8e543"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./datetime.mpx.js?isComponent&outputPath=components%2Fdatetime2fc8e543%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./datetime.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fdatetime2fc8e543%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2fc8e543"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/datetime2fc8e543/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-picker':getComponent(require("./index.mpx?isComponent&outputPath=components%2Findex65c978b8%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
